import { useMutation } from '@tanstack/react-query'
import { MessageReportReason, MessageReportPayload } from '../types/resources/message_report'
import { Haptic } from '../utils/native_adapters'
import { useApiClient } from './use_api_client'

export const useReportMessage = (conversationId: number, messageId: string) => {
  const apiClient = useApiClient()

  return useMutation({
    mutationFn: async ({
      reason,
      reasonDetail,
    }: {
      reason: MessageReportReason
      reasonDetail?: string
    }) => {
      const url = `/me/conversations/${conversationId}/messages/${messageId}/report`
      const data: MessageReportPayload = {
        data: {
          type: 'MessageReport',
          attributes: {
            reason,
            ...(reasonDetail && { reason_detail: reasonDetail }),
          },
        },
      }

      return apiClient.chat.post({ url, data })
    },
    onSuccess: () => {
      Haptic.notificationSuccess()
    },
    onError: () => {
      Haptic.notificationError()
    },
  })
}
